<template>
  <div>
    <z-centralized-toolbar>
      <!-- <v-toolbar-items> -->
        <v-btn
          id="btn_adicionar"
          depressed
          rounded
          color="primary"
          :to="{name: 'EstoqueAdicionar'}"
        >
          <v-icon left>mdi-plus</v-icon>Novo Movimento
        </v-btn>

        <v-btn 
          v-if="false" 
          id="btn_adicionar"
          text
          rounded 
          @click="abrirTransferencias"
        >
          <v-icon left>mdi-swap-horizontal-bold</v-icon>Transferências
        </v-btn>

        <menu-relatorios-estoque @abrir:relatorio="abrirRelatorio"></menu-relatorios-estoque>

        <v-btn
          id="btn_refresh"
          text
          icon
          :loading="$store.state.loading"
          @click="refresh"
        >
          <v-icon>mdi-refresh</v-icon>
          <v-tooltip bottom activator="#btn_refresh">Refresh</v-tooltip>
        </v-btn>
      <!-- </v-toolbar-items> -->

      <!-- <v-spacer></v-spacer> -->

      <z-text-field-search 
        v-model="search" 
        select 
        class="ml-5" 
        @keydown.enter="refresh" 
        @click:clear="limparBusca"
      ></z-text-field-search>
    </z-centralized-toolbar>

    <z-container>
      <h3 class="text-body-1 mb-3">Movimentação de Estoque</h3>

      <v-card>

        <v-data-table
          id="movimentos"
          item-key="id"
          disable-pagination
          :options.sync="options"
          :server-items-length="total_de_registros"
          :footer-props="$globals.FOOTER_PROPS"
          :headers="headers"
          :items="movimentos"
          :loading="false"
        >
          <template v-slot:item="{ item: movimento }">
            <tr>
              <td>{{ movimento.id }}</td>
              <td>{{ movimento.pedidocompra_id }}</td>
              <td>{{ movimento.data | dataBR }}</td>
              <td>{{ movimento.lote }}</td>
              <td>
                {{ movimento.fornecedor ? movimento.fornecedor.razao : "" }}
              </td>
              <td class="text-center">
                <v-chip
                  small
                  text-color="white"
                  color="green"
                  v-show="movimento.movimento == 'Entrada'"
                >
                  {{ movimento.movimento }}<span v-if="movimento.loja_origem">: {{ movimento.loja_origem.abreviacao }}</span>
                </v-chip>

                <v-chip
                  small
                  text-color="white"
                  color="red"
                  v-show="movimento.movimento == 'Saída'"
                >
                  {{ movimento.movimento }}<span v-if="movimento.loja_destino">: {{ movimento.loja_destino.abreviacao }}</span>
                </v-chip>
              </td>
              <!-- <td><span :class="[movimento.movimento == 'Entrada' ? 'green--text' : 'red--text', 'text-uppercase']">{{ movimento.movimento }}</span></td> -->
              <td class="text-center">{{ movimento.itens }}</td>
              <td class="text-right">{{ movimento.valor_total | valorBR }}</td>
              <td class="text-center text-no-wrap">
                <v-btn icon @click="imprimir(movimento)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>

                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense>
                    <v-list-item
                      v-if="configuracoes.ALTERAR_MOVIMENTO_ESTOQUE"
                      v-show="!(movimento.loja_destino && movimento.confirmada == 1) && !(movimento.loja_origem && movimento.movimento == 'Entrada')"
                      @click="editar(movimento)"
                    >
                      <v-list-item-action>
                        <v-icon>edit</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>Editar Movimento</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="visualizar(movimento)">
                      <v-list-item-action>
                        <v-icon> mdi-eye </v-icon>
                      </v-list-item-action>
                      <v-list-item-title>Visualizar Movimento</v-list-item-title>
                    </v-list-item>

                    <v-divider v-show="!(movimento.loja_destino && movimento.confirmada == 1)"></v-divider>
                    <v-list-item
                      class="red--text"
                      v-show="!(movimento.loja_destino && movimento.confirmada == 1)"
                      @click="perguntarExcluir(movimento)"ß
                    >
                      <v-list-item-action>
                        <v-icon color="red">delete</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>Excluir Movimento</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </z-container>

    <z-dialogo
      ref="dialogoExcluir"
      titulo="Deseja excluir movimento de estoque?"
      largura="500px"
      :dividers="true"ß
    >
      <div slot="texto">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Movimento</v-list-item-subtitle>
              <v-list-item-title>{{ movimento.id }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Fornecedor</v-list-item-subtitle>
              <v-list-item-title>{{movimento.fornecedor ? movimento.fornecedor.razao : ""}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>

      <v-btn text @click="$refs.dialogoExcluir.fechar()" :disabled="excluindo">Cancelar</v-btn>
      <v-btn
        color="primary darken-1"
        text
        :loading="excluindo"
        :disabled="excluindo"
        @click="confirmarExcluir"
        >Excluir</v-btn>
    </z-dialogo>

    <entradas-de-produtos ref="entradas" :relatorio="relatorio"></entradas-de-produtos>

    <dialogo-transferencias ref="dialogoTransferencias"></dialogo-transferencias>

    <z-dialogo-sim-nao
      ref="dialogoImpressaoTerminca"
      titulo="Imprimir na impressora térmica?"
      botaoSim="Impressora Térmica"
      botaoNao="Impressora Padrão"
      largura="500px"
    >
      A impressora térmica está habilitada no sistema. Deseja imprimir na impressora térmica?
    </z-dialogo-sim-nao>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import MenuRelatoriosEstoque from "./MenuRelatoriosEstoque";
import EntradasDeProdutos from "./relatorios/EntradasDeProdutos";
import DialogoTransferencias from "./DialogoTransferencias";
import { useConfigStore } from '@/app/store/pinia/configuracoes'
import movimentoEstoqueApi from '@/app/services/movimentoestoque';

export default {
  name: "estoque-lista",
  components: {
    MenuRelatoriosEstoque,
    EntradasDeProdutos,
    DialogoTransferencias,
  },

  inject: ["$imprimir"],

  data() {
    return {
      // globals,
      headers: [
        { text: "#", value: "id", width: "90px" },
        { text: "Pedido Compra", value: "pedidocompra_id", width: "180px" },
        { text: "Data", value: "data" },
        { text: "Lote", value: "lote"},
        { text: "Fornecedor", value: "fornecedor.razao" },
        { text: "Movimento", value: "movimento", width: "100px" },
        { text: "Itens", value: "itens", align: "center"},
        { text: "Total", value: "valor_total", align: "right", width: "100px" },
        { text: "Opções", value: "", align: "center", sortable: false },
      ],
      excluindo: false,
      movimento: {
        fornecedor: {
          razao: "",
        },
      },
      // options: this.$globals.TABLE_OPTIONS,
      listagem: "todos",
      sheet: false,
      relatorio: "",
      // search: ''
      configuracoes: useConfigStore().configuracoes,
    };
  },

  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     vm.options.page = 1;
  //   });
  // },

  beforeRouteLeave(to, from, next) {
    if (["EstoqueEditar", "EstoqueVisualizar"].indexOf(to.name) == -1) {
      this.$store.commit("movimentoestoque/SET_PAGE", 1);
      this.$store.commit("movimentoestoque/SET_SEARCH", "");
      // this.refresh();
    }
    next();
  },

  mounted() {
    this.setTitulo("Movimento de Estoque");
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapActions("movimentoestoque", ["listar", "excluir", "abrir"]),

    async refresh() {
      try {
        await this.listar();
      } catch (error) {
        this.$eventbus.erro(
          "Não foi possível obter a lista do movimentos.",
          error
        );
        this.LOADING_OFF();
      }
    },

    async editar(movimento) {
      try {
        await this.abrir(movimento.id);
        this.$router.push({
          name: "EstoqueEditar",
          params: { id: movimento.id },
        });
      } catch (error) {
        this.$eventbus.erro("Não foi possível abrir este movimento.", error);
        this.LOADING_OFF();
      }
    },

    async visualizar(movimento) {
      try {
        await this.abrir(movimento.id);
        this.$router.push({
          name: "EstoqueVisualizar",
          params: { id: movimento.id },
        });
      } catch (error) {
        this.$eventbus.erro("Não foi possível abrir este movimento.", error);
        this.LOADING_OFF();
      }
    },

    perguntarExcluir(movimento) {
      this.movimento = movimento;
      this.$refs.dialogoExcluir.abrir();
    },

    async confirmarExcluir() {
      try {
        this.excluindo = true;
        await this.excluir(this.movimento.id);
        this.$eventbus.notificar("Movimento excluído com sucesso!");
      } catch (error) {
        this.$eventbus.erro("Não foi possível excluir o movimento.", error);
      } finally {
        this.$refs.dialogoExcluir.fechar();
        this.excluindo = false;
      }
    },

    limparBusca() {
      this.search = "";
      this.$store.commit("movimentoestoque/SET_PAGE", 1);
      this.refresh();
    },

    async imprimir(movimento) {
      const impressao_termica = await this.imprimirNaImpressoraTermica();

      if (impressao_termica) {
        movimentoEstoqueApi.impressaoTerminca(movimento);
      } else {
        this.$imprimir("/movimentos/" + movimento.id + "/imprimir", "Movimento_" + movimento.id + ".pdf");
      }
    },

    async imprimirNaImpressoraTermica() {
      let response = false;
      if (this.configuracoes.APP_IMPRESSAO_TERMICA) {
        response = await this.$refs.dialogoImpressaoTerminca.abrir();
      }

      this.$refs.dialogoImpressaoTerminca.fechar();
      return this.configuracoes.APP_IMPRESSAO_TERMICA && response === true;
    },

    updatePagination(options) {
      this.$store.commit("movimentoestoque/UPDATE_PAGINATION", options);
    },

    abrirRelatorio(relatorio) {
      this.relatorio = relatorio;

      const relatorios = [
        "entradaDeProdutosPeriodo", 
        "entradaDeProdutosValorCusto",
        "entradaSaidaDeProdutos",
        "entradaDeLotesProdutosPeriodo"
      ];

      if (relatorios.indexOf(relatorio) > -1) {
        this.$refs.entradas.abrir();
      }
    },

    abrirTransferencias() {
      this.$refs.dialogoTransferencias.abrir();
    },
  },

  computed: {
    ...mapState("movimentoestoque", [
      "movimentos",
      "pagination",
      "total_de_registros",
    ]),

    search: {
      get() {
        return this.$store.state.movimentoestoque.search;
      },
      set(search) {
        this.$store.commit("movimentoestoque/SET_SEARCH", search);
      },
    },

    options: {
      get() {
        return {
          ...this.$store.state.movimentoestoque.pagination,
          ...this.$globals.TABLE_OPTIONS.itemsPerPage,
        };
      },
      set(options) {
        this.$store.commit("movimentoestoque/UPDATE_PAGINATION", options);
      },
    },
  },

  watch: {
    options: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.x-small {
  font-size: 11px;
  height: 18px;
}
</style>
